<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Video Series</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <strong>Add new video</strong>
            <router-link
              class="btn btn-primary btn-sm pull-right"
              :to="{ name: 'VideoSeriesManageVideos', params: { id: $route.params.id }}"
            >
              Manage Video
            </router-link>
          </div>

          <div class="card-block">
            <div class="row images-dd__wrap">
              <div class="col-md-6">
                <div class="images-dd__target-zone">
                  <div class="images-dd__target-zone__title">
                    Videos which will add to gallery:
                  </div>
                  <div class="images-dd__list">
                    <div
                      v-for="item in selectedVideos"
                      :key="item.id"
                      class="images-dd__item"
                      :data-id="item.id"
                      :title="item.title"
                    >
                      <div class="images-dd__item__img">
                        <img :src="item.thumbnail" alt="">
                      </div>
                      <div class="images-dd__item__title">{{ shortTitle(item.title) }}</div>
                      <div class="images-dd__item__cover" @click="deleteVideo(item)">
                        <i class="fa fa-minus" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="images-dd__source-wrap spinner-parent">
                  <div class="images-dd__source-search">
                    <input
                      v-model="searchQuery"
                      type="text"
                      class="form-control"
                      placeholder="Search by video title"
                    >
                  </div>

                  <div class="spinner-parent">
                    <spinner ref="sourceSpinner" size="md" text="Loading ..." />

                    <div class="images-dd__list">
                      <div
                        v-for="item in sourceVideos"
                        :key="item.id"
                        class="images-dd__item"
                        :data-id="item.id"
                      >
                        <div class="images-dd__item__img">
                          <img :src="item.thumbnail" alt="">
                        </div>
                        <div class="images-dd__item__title" :title="item.title">
                          {{ shortTitle(item.title) }}
                        </div>
                        <div class="images-dd__item__cover" @click="addVideo(item)">
                          <i class="fa fa-plus" />
                        </div>
                      </div>

                      <div v-if="!total" class="images-dd__list--empty">
                        There are no items on your request
                      </div>
                    </div>

                    <nav class="images-dd__source-nav">
                      <pager
                        :total="total"
                        :offset="offset"
                        :size="perPage"
                        @page-changed="changePage"
                      />
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save Videos
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Videos have saved successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';

export default {
  name: 'VideoSeriesAddVideos',

  components: {
    pager: Pager,
  },

  data() {
    return {
      searchProcessId: null,
      searchQuery: '',
      total: 0,
      perPage: 0,
      offset: 0,
      sourceVideos: [],
      selectedVideos: [],
      saveErrorMessage: 'Error in data saving',
    };
  },

  watch: {
    searchQuery: _.debounce(function () {
      this.offset = 0;
      this.getSourceVideos();
    }, 400),
    offset() {
      this.getSourceVideos();
    },
  },

  mounted() {
    this.getSourceVideos();
  },

  methods: {
    shortTitle(title) {
      if (title.length > 30) {
        return `${title.slice(0, 30)}...`;
      }
      return title;
    },
    addVideo(video) {
      const index = _.findIndex(this.selectedVideos, item => video.id === item.id);
      if (index === -1) {
        this.selectedVideos.push(video);
      }
    },
    deleteVideo(video) {
      _.remove(this.selectedVideos, item => item.id === video.id);
      this.$forceUpdate();
    },
    getSourceVideos() {
      if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/video`, {
        params: {
          search_string: searchString,
          page,
          with: ['cover'],
        },
      })
        .then((response) => {
          if (this.searchProcessId === searchProcessId) {
            if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.hide(); }
            this.total = response.data.meta.pagination.total;
            this.perPage = response.data.meta.pagination.per_page;

            const videosArr = _.cloneDeep(response.data);
            delete videosArr.meta;
            this.sourceVideos = videosArr;
          }
        }).catch((error) => {
          if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.hide(); }
          console.error(error);
        });
    },
    changePage(offset) {
      this.offset = offset;
    },
    isEntityValid() {
      if (!this.selectedVideos.length) {
        this.errorSave('You should choose at least one video');
        return false;
      }
      return true;
    },
    saveRequest() {
      const postFormData = new FormData();
      for (let i = 0; i < this.selectedVideos.length; i += 1) {
        postFormData.append('ids[]', this.selectedVideos[i].id);
      }
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}media/video-series/${this.$route.params.id}/attach-videos`,
        postFormData,
      );
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(() => {
        this.successSave();
        this.selectedVideos = [];
        this.$forceUpdate();
      }).catch((error) => {
        this.errorSave('Error in data saving');
        console.error('Error in add videos to series query', error);
      });
    },
    successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },
  },
};
</script>



// WEBPACK FOOTER //
// AddVideos.vue?24d4822d